<template>
  <card-canvas class="people-create">
    <card-canvas-two-deep-breadcrumb
      :parent-route="RouteAssistant.getPeopleRoute($route.params.accountId)"
      child-name="Company"
      parent-name="Invite New Users" />
    <h2>Invite New Users</h2>
    <p>
      Enter an email address and choose their company and role.
      <strong>Admins</strong> can invite new users to the account, create new Projects &amp; Mailboxes, and manage their settings.
      <strong>Owners</strong> can do all that plus access account settings and billing.
    </p>
    <add-people-form @account-memberships-created="RouteAssistant.goToPeople($router, $route.params.accountId)" />
  </card-canvas>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import CardCanvas from '@/layouts/card-canvas.vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'PeopleCreate',

  components: {
    CardCanvas,
  },

  data() {
    return {
      RouteAssistant,
    }
  },

  head: {
    title: 'Invite New Users',
  },
})
</script>

<style lang="scss">
</style>
